import { Select } from "../../components/Select/Select.ts";

(function () {
    if (document.querySelectorAll(".js-smepsc-block").length > 0) {

        const smeProductServicesCategoryBlock = {
            init: () => {
                const selectElements = document.querySelectorAll(".js-select-component");
                selectElements.forEach((selectElement, index) => {
                    new Select(selectElement, index);
                });
                smeProductServicesCategoryBlock.clickFilter();
            },
            clickFilter: () => {
                const categoryBlocks = document.querySelectorAll(".js-smepsc-block");

                categoryBlocks.forEach((block) => {
                    const categoryButtons = block.querySelectorAll(".js-smespc-filter");
                    const selectButtons = block.querySelectorAll("[js-select-item]");

                    categoryButtons.forEach((categoryButton) => {
                        categoryButton.addEventListener("click", (e) => {
                            const selectedIndex = e.currentTarget.dataset.category;

                            smeProductServicesCategoryBlock.displayFiltered(block, selectedIndex);
                        })
                    });

                    selectButtons.forEach((selectButton, index) => {
                        if (index === 0) {
                            selectButton.classList.add("checked");
                        }
                        selectButton.addEventListener("click", (e) => {
                            const selectedIndex = e.currentTarget.dataset.selectValue;

                            smeProductServicesCategoryBlock.displayFiltered(block, selectedIndex);
                        })
                    });
                });
            },
            displayFiltered: (currentBlock, index) => {
                const panelsText = currentBlock.querySelectorAll(".col-left div[data-category]");
                const panelsCards = currentBlock.querySelectorAll(".col-right div[data-category]");
                const filterButtons = currentBlock.querySelectorAll(".js-smespc-filter");
                const activeButton = currentBlock.querySelector(".sb__ctas button.active");

                panelsText.forEach((panelText) => {
                    panelText.style.display = "none";

                });

                panelsCards.forEach((panelCard) => {
                    panelCard.style.display = "none";

                });

                activeButton.classList.remove("active");

                panelsText[index].style.display = "block";
                panelsCards[index].style.display = "block";
                filterButtons[index].classList.add("active");
            },
        };

        smeProductServicesCategoryBlock.init();
    }
})();

